document.querySelectorAll( '.b-tagline' ).forEach( ( block ) => {

	const elements = block.querySelectorAll( '.b-tagline-element' );
	if ( elements.length <= 1 ) {

		return;

	}

	let current = 0;
	// Hide all except the first one
	elements.forEach( ( el, idx ) => {

		el.style.display = idx === 0 ? '' : 'none';

	} );


	/**
	 * Animates the text of the given tagline element by simulating a typing effect
	 * on its title. The title text is revealed one character at a time.
	 *
	 * @param {Element} element - The tagline element containing the title to animate.
	 */
	const animateText = ( element ) => {

		const title = element.querySelector( '.b-tagline-element__title' );
		if ( !title ) {

			return;

		}
		const fullText = title.textContent;
		title.textContent = '';
		let i = 0;

		/**
		 * Types the next character of the title text, creating a typing animation effect.
		 * Increments the index and updates the text content until the full text is displayed.
		 */
		const typeNext = () => {

			if ( i <= fullText.length ) {

				title.textContent = fullText.slice( 0, i );
				i++;
				setTimeout( typeNext, 40 ); // Typing speed

			}

		}
		setTimeout( typeNext, 1000 ); // Initial delay before starting

	}

	// Animate the text of the first element at startup
	animateText( elements[0] );

	setInterval( () => {

		elements[current].style.display = 'none';
		current = ( current + 1 ) % elements.length;
		elements[current].style.display = '';
		animateText( elements[current] );

	}, 5000 );

} );
